module.exports = __webpack_public_path__ + "img/logo-with-word.24dbadcf.png";